import { call, race, getContext, delay } from 'redux-saga/effects';

const contextKey = '__routingContext';
function* getRoutingContext() {
    const [ctx1] = yield race([
        call(function* attemptToGetContext() {
            while(true){
                const ctx = yield getContext(contextKey);
                if (ctx) {
                    return ctx;
                }
                yield delay(10);
            }
        }),
        delay(1000), 
    ]);
    if (!ctx1) {
        console.warn('timed out getting RoutingContext for sagas');
    }
    return ctx1;
}
function* getUrlFormatter() {
    const routingContext = yield call(getRoutingContext);
    return routingContext.format;
}
function* pushLocation(url) {
    const routingContext = yield call(getRoutingContext);
    return yield call(routingContext.push, url);
}
function* replaceLocation(url) {
    const routingContext = yield call(getRoutingContext);
    return yield call(routingContext.replace, url);
}

export { contextKey, getUrlFormatter, pushLocation, replaceLocation };
//# sourceMappingURL=routing.js.map
